interface TypeBusiness {
  icon?: string;
  name: string;
}
interface ArticleBusiness {
  image?: string;
  title: string;
  description: string;
}
export  default  class BusinessLocale {
  public title: string = "";
  public description: string = "";
  public type_icons: Array<TypeBusiness> = [];
  public articles_locale: Array<ArticleBusiness> = [];
  constructor() {
    const { locale } = useI18n();
    const businessLocale = typeIcons.find(
      (item) => item.locale == locale.value
    );
    this.type_icons = businessLocale?.data ?? typeIcons[0].data;

    const articlesLocale = articles.find((item) => item.locale == locale.value);
    this.articles_locale = articlesLocale?.data ?? articles[0].data;

    const contentLocale = content.find((item) => item.locale == locale.value);
    this.title = contentLocale?.title ?? content[0].title;
    this.description = contentLocale?.description ?? content[0].description;
  }
}

const content: Array<{
  locale: string;
  title: string;
  description: string;
}> = [
  {
    locale: "en",
    title: `QR Codes for <span class="text-success">Everything</span>`,
    description:
      "Applying QR code technology in querying tasks reduces the workload of employees in manual comparison and verification, enhances the security, efficiency, and accuracy of information, enables fast and automated queries, and improves the service for suppliers",
  },
  {
    locale: "vi",
    title: `Mã QR cho <span class="text-success block">mọi thứ</span>`,
    description:
      "Việc áp dụng công nghệ mã QR vào các nhiệm vụ truy vấn giảm thiểu khối lượng công việc của nhân viên trong việc so sánh và xác thực thủ công, nâng cao tính bảo mật, hiệu quả và độ chính xác của thông tin, cho phép truy vấn nhanh và tự động, và cải thiện dịch vụ cho các nhà cung cấp.",
  },
  {
    locale: "es",
    title: `Códigos QR para <span class="text-success"> Todo</span>`,
    description:
      "La aplicación de la tecnología de códigos QR en las tareas de consulta reduce la carga de trabajo de los empleados en la comparación y verificación manual, mejora la seguridad, eficiencia y precisión de la información, permite consultas rápidas y automatizadas, y mejora el servicio para los proveedores.",
  },
  {
    locale: "fr",
    title: `Codes QR pour <span class="text-success">Tout</span>`,
    description:
      "L'application de la technologie des codes QR dans les tâches de consultation réduit la charge de travail des employés dans la comparaison et la vérification manuelle, améliore la sécurité, l'efficacité et la précision des informations, permet des consultations rapides et automatisées, et améliore le service pour les fournisseurs.",
  },
  {
    locale: "de",
    title: `QR-Codes für <span class="text-success">Alles</span>`,
    description:
      "Die Anwendung der QR-Code-Technologie bei Abfrageaufgaben reduziert die Arbeitsbelastung der Mitarbeiter bei manuellem Vergleich und Überprüfung, verbessert die Sicherheit, Effizienz und Genauigkeit der Informationen, ermöglicht schnelle und automatisierte Abfragen und verbessert den Service für Lieferanten.",
  },
  {
    locale: "it",
    title: `Codici QR per <span class="text-success">Tutto</span>`,
    description:
      "L'applicazione della tecnologia dei codici QR nei compiti di consultazione riduce il carico di lavoro dei dipendenti nella comparazione e verifica manuale, migliora la sicurezza, l'efficienza e la precisione delle informazioni, consente consultazioni rapide e automatizzate e migliora il servizio per i fornitori.",
  },
  {
    locale: "ja",
    title: `<span class="text-success">あらゆるもの</span>にQRコードを`,
    description:
      "QRコード技術を使用して問い合わせタスクを行うことで、従業員の手作業による比較や検証の負担を軽減し、情報のセキュリティ、効率性、正確性を高め、迅速かつ自動化された問い合わせを可能にし、サプライヤーに対するサービスを向上させます。",
  },
  {
    locale: "nl",
    title: `QR-codes voor <span class="text-success">Alles</span>`,
    description:
      "Het gebruik van QR-code technologie bij opvraagtaken vermindert de werklast van werknemers bij handmatige vergelijking en verificatie, verbetert de beveiliging, efficiëntie en nauwkeurigheid van informatie, maakt snelle en geautomatiseerde opvragingen mogelijk, en verbetert de service voor leveranciers.",
  },
  {
    locale: "pt",
    title: `Códigos QR para <span class="text-success">Tudo</span>`,
    description:
      "A aplicação da tecnologia de códigos QR em tarefas de consulta reduz a carga de trabalho dos funcionários na comparação e verificação manual, melhora a segurança, eficiência e precisão das informações, permite consultas rápidas e automatizadas e melhora o serviço para os fornecedores.",
  },
  {
    locale: "zh",
    title: `二维码用于<span class="text-success">万物</span>`,
    description:
      "将QR码技术应用于查询任务可以减轻员工在手动比对和验证中的工作量，增强信息的安全性、效率和准确性，实现快速自动化查询，并提高对供应商的服务。",
  },
];

const typeIcons: Array<{
  locale: string;
  data: Array<TypeBusiness>;
}> = [
  {
    locale: "en",
    data: [
      {
        icon: "PlaneInflightIcon",
        name: "Tourism",
      },
      {
        icon: "IdIcon",
        name: "Personal Use",
      },
      {
        icon: "CameraIcon",
        name: "Photographer & Videographer",
      },
      {
        icon: "BuildingBridgeIcon",
        name: "Cities & Culture",
      },
      {
        icon: "CalendarIcon",
        name: "Event Management",
      },
      {
        icon: "MusicIcon",
        name: "Musician & Artists",
      },
      {
        icon: "HammerIcon",
        name: "Home & Repair",
      },
      {
        icon: "HeartIcon",
        name: "Finance & Insurance",
      },
      {
        icon: "BrandHipchatIcon",
        name: "Business Consultants",
      },
      {
        icon: "BulbIcon",
        name: "Publishers",
      },
      {
        icon: "BuildingEstateIcon",
        name: "Real Estate",
      },
      {
        icon: "BeerIcon",
        name: "Restaurants & Bars",
      },
      {
        icon: "ShoppingCartIcon",
        name: "Retail",
      },
      {
        icon: "DeviceLaptopIcon",
        name: "Software & IT",
      },
      {
        icon: "PlanetIcon",
        name: "Nonprofits",
      },
      {
        icon: "BuildingSkyscraperIcon",
        name: "Hotels & Resorts",
      },
      {
        icon: "BuildingBankIcon",
        name: "Government",
      },
      {
        icon: "SchoolIcon",
        name: "Educational Institutions",
      },
      {
        icon: "AssemblyIcon",
        name: "Products",
      },
      {
        icon: "MedicalCrossIcon",
        name: "Doctors & Healthcare",
      },
    ],
  },
  {
    locale: "zh",
    data: [
      {
        icon: "PlaneInflightIcon",
        name: "旅游业",
      },
      {
        icon: "IdIcon",
        name: "个人使用",
      },
      {
        icon: "CameraIcon",
        name: "摄影师和视频制作人员",
      },
      {
        icon: "BuildingBridgeIcon",
        name: "城市和文化",
      },
      {
        icon: "CalendarIcon",
        name: "活动管理",
      },
      {
        icon: "MusicIcon",
        name: "音乐家和艺术家",
      },
      {
        icon: "HammerIcon",
        name: "家庭维修",
      },
      {
        icon: "HeartIcon",
        name: "金融和保险",
      },
      {
        icon: "BrandHipchatIcon",
        name: "商业顾问",
      },
      {
        icon: "BulbIcon",
        name: "出版商",
      },
      {
        icon: "BuildingEstateIcon",
        name: "房地产",
      },
      {
        icon: "BeerIcon",
        name: "餐厅和酒吧",
      },
      {
        icon: "ShoppingCartIcon",
        name: "零售业",
      },
      {
        icon: "DeviceLaptopIcon",
        name: "软件和IT",
      },
      {
        icon: "PlanetIcon",
        name: "非营利组织",
      },
      {
        icon: "BuildingSkyscraperIcon",
        name: "酒店和度假村",
      },
      {
        icon: "BuildingBankIcon",
        name: "政府",
      },
      {
        icon: "SchoolIcon",
        name: "教育机构",
      },
      {
        icon: "AssemblyIcon",
        name: "产品",
      },
      {
        icon: "MedicalCrossIcon",
        name: "医生和医疗保健",
      },
    ],
  },
  {
    locale: "vi",
    data: [
      {
        icon: "PlaneInflightIcon",
        name: "Du lịch",
      },
      {
        icon: "IdIcon",
        name: "Sử dụng cá nhân",
      },
      {
        icon: "CameraIcon",
        name: "Nhiếp ảnh & Quay phim",
      },
      {
        icon: "BuildingBridgeIcon",
        name: "Thành phố & Văn hóa",
      },
      {
        icon: "CalendarIcon",
        name: "Quản lý sự kiện",
      },
      {
        icon: "MusicIcon",
        name: "Nhạc sĩ & Nghệ sĩ",
      },
      {
        icon: "HammerIcon",
        name: "Nhà & Sửa chữa",
      },
      {
        icon: "HeartIcon",
        name: "Tài chính & Bảo hiểm",
      },
      {
        icon: "BrandHipchatIcon",
        name: "Tư vấn kinh doanh",
      },
      {
        icon: "BulbIcon",
        name: "Nhà xuất bản",
      },
      {
        icon: "BuildingEstateIcon",
        name: "Bất động sản",
      },
      {
        icon: "BeerIcon",
        name: "Nhà hàng & Quán bar",
      },
      {
        icon: "ShoppingCartIcon",
        name: "Bán lẻ",
      },
      {
        icon: "DeviceLaptopIcon",
        name: "Phần mềm & Công nghệ thông tin",
      },
      {
        icon: "PlanetIcon",
        name: "Tổ chức phi lợi nhuận",
      },
      {
        icon: "BuildingSkyscraperIcon",
        name: "Khách sạn & Khu nghỉ dưỡng",
      },
      {
        icon: "BuildingBankIcon",
        name: "Chính phủ",
      },
      {
        icon: "SchoolIcon",
        name: "Các tổ chức giáo dục",
      },
      {
        icon: "AssemblyIcon",
        name: "Sản phẩm",
      },
      {
        icon: "MedicalCrossIcon",
        name: "Bác sĩ & Chăm sóc sức khỏe",
      },
    ],
  },
  {
    locale: "de",
    data: [
      {
        icon: "PlaneInflightIcon",
        name: "Tourismus",
      },
      {
        icon: "IdIcon",
        name: "Persönliche Nutzung",
      },
      {
        icon: "CameraIcon",
        name: "Fotografen & Videografen",
      },
      {
        icon: "BuildingBridgeIcon",
        name: "Städte & Kultur",
      },
      {
        icon: "CalendarIcon",
        name: "Veranstaltungsmanagement",
      },
      {
        icon: "MusicIcon",
        name: "Musiker & Künstler",
      },
      {
        icon: "HammerIcon",
        name: "Haus & Reparatur",
      },
      {
        icon: "HeartIcon",
        name: "Finanzen & Versicherungen",
      },
      {
        icon: "BrandHipchatIcon",
        name: "Unternehmensberater",
      },
      {
        icon: "BulbIcon",
        name: "Verlage",
      },
      {
        icon: "BuildingEstateIcon",
        name: "Immobilien",
      },
      {
        icon: "BeerIcon",
        name: "Restaurants & Bars",
      },
      {
        icon: "ShoppingCartIcon",
        name: "Einzelhandel",
      },
      {
        icon: "DeviceLaptopIcon",
        name: "Software & IT",
      },
      {
        icon: "PlanetIcon",
        name: "Nonprofit-Organisationen",
      },
      {
        icon: "BuildingSkyscraperIcon",
        name: "Hotels & Resorts",
      },
      {
        icon: "BuildingBankIcon",
        name: "Regierung",
      },
      {
        icon: "SchoolIcon",
        name: "Bildungseinrichtungen",
      },
      {
        icon: "AssemblyIcon",
        name: "Produkte",
      },
      {
        icon: "MedicalCrossIcon",
        name: "Ärzte & Gesundheitswesen",
      },
    ],
  },
  {
    locale: "es",
    data: [
      {
        icon: "PlaneInflightIcon",
        name: "Turismo",
      },
      {
        icon: "IdIcon",
        name: "Uso Personal",
      },
      {
        icon: "CameraIcon",
        name: "Fotógrafos y Videógrafos",
      },
      {
        icon: "BuildingBridgeIcon",
        name: "Ciudades y Cultura",
      },
      {
        icon: "CalendarIcon",
        name: "Gestión de Eventos",
      },
      {
        icon: "MusicIcon",
        name: "Músicos y Artistas",
      },
      {
        icon: "HammerIcon",
        name: "Hogar y Reparación",
      },
      {
        icon: "HeartIcon",
        name: "Finanzas y Seguros",
      },
      {
        icon: "BrandHipchatIcon",
        name: "Consultores de Negocios",
      },
      {
        icon: "BulbIcon",
        name: "Editoriales",
      },
      {
        icon: "BuildingEstateIcon",
        name: "Bienes Raíces",
      },
      {
        icon: "BeerIcon",
        name: "Restaurantes y Bares",
      },
      {
        icon: "ShoppingCartIcon",
        name: "Minoristas",
      },
      {
        icon: "DeviceLaptopIcon",
        name: "Software y Tecnología de la Información",
      },
      {
        icon: "PlanetIcon",
        name: "Organizaciones sin Fines de Lucro",
      },
      {
        icon: "BuildingSkyscraperIcon",
        name: "Hoteles y Resorts",
      },
      {
        icon: "BuildingBankIcon",
        name: "Gobierno",
      },
      {
        icon: "SchoolIcon",
        name: "Instituciones Educativas",
      },
      {
        icon: "AssemblyIcon",
        name: "Productos",
      },
      {
        icon: "MedicalCrossIcon",
        name: "Médicos y Cuidado de la Salud",
      },
    ],
  },
  {
    locale: "fr",
    data: [
      {
        icon: "PlaneInflightIcon",
        name: "Tourisme",
      },
      {
        icon: "IdIcon",
        name: "Usage personnel",
      },
      {
        icon: "CameraIcon",
        name: "Photographe et vidéaste",
      },
      {
        icon: "BuildingBridgeIcon",
        name: "Villes et culture",
      },
      {
        icon: "CalendarIcon",
        name: "Gestion d'événements",
      },
      {
        icon: "MusicIcon",
        name: "Musiciens et artistes",
      },
      {
        icon: "HammerIcon",
        name: "Maison et réparation",
      },
      {
        icon: "HeartIcon",
        name: "Finance et assurance",
      },
      {
        icon: "BrandHipchatIcon",
        name: "Conseillers en entreprise",
      },
      {
        icon: "BulbIcon",
        name: "Éditeurs",
      },
      {
        icon: "BuildingEstateIcon",
        name: "Immobilier",
      },
      {
        icon: "BeerIcon",
        name: "Restaurants et bars",
      },
      {
        icon: "ShoppingCartIcon",
        name: "Vente au détail",
      },
      {
        icon: "DeviceLaptopIcon",
        name: "Logiciels et informatique",
      },
      {
        icon: "PlanetIcon",
        name: "Organisations à but non lucratif",
      },
      {
        icon: "BuildingSkyscraperIcon",
        name: "Hôtels et centres de villégiature",
      },
      {
        icon: "BuildingBankIcon",
        name: "Gouvernement",
      },
      {
        icon: "SchoolIcon",
        name: "Institutions éducatives",
      },
      {
        icon: "AssemblyIcon",
        name: "Produits",
      },
      {
        icon: "MedicalCrossIcon",
        name: "Médecins et soins de santé",
      },
    ],
  },
  {
    locale: "pt",
    data: [
      {
        icon: "PlaneInflightIcon",
        name: "Turismo",
      },
      {
        icon: "IdIcon",
        name: "Uso pessoal",
      },
      {
        icon: "CameraIcon",
        name: "Fotógrafo e Videógrafo",
      },
      {
        icon: "BuildingBridgeIcon",
        name: "Cidades e Cultura",
      },
      {
        icon: "CalendarIcon",
        name: "Gestão de Eventos",
      },
      {
        icon: "MusicIcon",
        name: "Músicos e Artistas",
      },
      {
        icon: "HammerIcon",
        name: "Casa e Reparação",
      },
      {
        icon: "HeartIcon",
        name: "Finanças e Seguros",
      },
      {
        icon: "BrandHipchatIcon",
        name: "Consultores de Negócios",
      },
      {
        icon: "BulbIcon",
        name: "Editores",
      },
      {
        icon: "BuildingEstateIcon",
        name: "Imóveis",
      },
      {
        icon: "BeerIcon",
        name: "Restaurantes e Bares",
      },
      {
        icon: "ShoppingCartIcon",
        name: "Varejo",
      },
      {
        icon: "DeviceLaptopIcon",
        name: "Software e TI",
      },
      {
        icon: "PlanetIcon",
        name: "Organizações sem fins lucrativos",
      },
      {
        icon: "BuildingSkyscraperIcon",
        name: "Hotéis e Resorts",
      },
      {
        icon: "BuildingBankIcon",
        name: "Governo",
      },
      {
        icon: "SchoolIcon",
        name: "Instituições Educacionais",
      },
      {
        icon: "AssemblyIcon",
        name: "Produtos",
      },
      {
        icon: "MedicalCrossIcon",
        name: "Médicos e Cuidados de Saúde",
      },
    ],
  },
  {
    locale: "it",
    data: [
      {
        icon: "PlaneInflightIcon",
        name: "Turismo",
      },
      {
        icon: "IdIcon",
        name: "Uso personale",
      },
      {
        icon: "CameraIcon",
        name: "Fotografo e Videografo",
      },
      {
        icon: "BuildingBridgeIcon",
        name: "Città e Cultura",
      },
      {
        icon: "CalendarIcon",
        name: "Gestione eventi",
      },
      {
        icon: "MusicIcon",
        name: "Musicisti e Artisti",
      },
      {
        icon: "HammerIcon",
        name: "Casa e Riparazioni",
      },
      {
        icon: "HeartIcon",
        name: "Finanza e Assicurazione",
      },
      {
        icon: "BrandHipchatIcon",
        name: "Consulenti Aziendali",
      },
      {
        icon: "BulbIcon",
        name: "Editori",
      },
      {
        icon: "BuildingEstateIcon",
        name: "Immobiliare",
      },
      {
        icon: "BeerIcon",
        name: "Ristoranti e Bar",
      },
      {
        icon: "ShoppingCartIcon",
        name: "Commercio al dettaglio",
      },
      {
        icon: "DeviceLaptopIcon",
        name: "Software e IT",
      },
      {
        icon: "PlanetIcon",
        name: "Organizzazioni non profit",
      },
      {
        icon: "BuildingSkyscraperIcon",
        name: "Hotel e Resort",
      },
      {
        icon: "BuildingBankIcon",
        name: "Governo",
      },
      {
        icon: "SchoolIcon",
        name: "Istituti Educativi",
      },
      {
        icon: "AssemblyIcon",
        name: "Prodotti",
      },
      {
        icon: "MedicalCrossIcon",
        name: "Medici e Assistenza Sanitaria",
      },
    ],
  },
  {
    locale: "nl",
    data: [
      {
        icon: "PlaneInflightIcon",
        name: "Toerisme",
      },
      {
        icon: "IdIcon",
        name: "Persoonlijk gebruik",
      },
      {
        icon: "CameraIcon",
        name: "Fotograaf en videograaf",
      },
      {
        icon: "BuildingBridgeIcon",
        name: "Steden en cultuur",
      },
      {
        icon: "CalendarIcon",
        name: "Evenementenbeheer",
      },
      {
        icon: "MusicIcon",
        name: "Muzikanten en artiesten",
      },
      {
        icon: "HammerIcon",
        name: "Huis en reparatie",
      },
      {
        icon: "HeartIcon",
        name: "Financiën en verzekeringen",
      },
      {
        icon: "BrandHipchatIcon",
        name: "Zakelijke consultants",
      },
      {
        icon: "BulbIcon",
        name: "Uitgevers",
      },
      {
        icon: "BuildingEstateIcon",
        name: "Vastgoed",
      },
      {
        icon: "BeerIcon",
        name: "Restaurants en bars",
      },
      {
        icon: "ShoppingCartIcon",
        name: "Detailhandel",
      },
      {
        icon: "DeviceLaptopIcon",
        name: "Software en IT",
      },
      {
        icon: "PlanetIcon",
        name: "Non-profitorganisaties",
      },
      {
        icon: "BuildingSkyscraperIcon",
        name: "Hotels en resorts",
      },
      {
        icon: "BuildingBankIcon",
        name: "Overheid",
      },
      {
        icon: "SchoolIcon",
        name: "Onderwijsinstellingen",
      },
      {
        icon: "AssemblyIcon",
        name: "Producten",
      },
      {
        icon: "MedicalCrossIcon",
        name: "Artsen en gezondheidszorg",
      },
    ],
  },
  {
    locale: "ja",
    data: [
      {
        icon: "PlaneInflightIcon",
        name: "観光",
      },
      {
        icon: "IdIcon",
        name: "個人利用",
      },
      {
        icon: "CameraIcon",
        name: "写真家・ビデオグラファー",
      },
      {
        icon: "BuildingBridgeIcon",
        name: "都市と文化",
      },
      {
        icon: "CalendarIcon",
        name: "イベント管理",
      },
      {
        icon: "MusicIcon",
        name: "ミュージシャン・アーティスト",
      },
      {
        icon: "HammerIcon",
        name: "家庭・修理",
      },
      {
        icon: "HeartIcon",
        name: "金融・保険",
      },
      {
        icon: "BrandHipchatIcon",
        name: "ビジネスコンサルタント",
      },
      {
        icon: "BulbIcon",
        name: "出版社",
      },
      {
        icon: "BuildingEstateIcon",
        name: "不動産",
      },
      {
        icon: "BeerIcon",
        name: "レストラン・バー",
      },
      {
        icon: "ShoppingCartIcon",
        name: "小売",
      },
      {
        icon: "DeviceLaptopIcon",
        name: "ソフトウェア・IT",
      },
      {
        icon: "PlanetIcon",
        name: "非営利団体",
      },
      {
        icon: "BuildingSkyscraperIcon",
        name: "ホテル・リゾート",
      },
      {
        icon: "BuildingBankIcon",
        name: "政府",
      },
      {
        icon: "SchoolIcon",
        name: "教育機関",
      },
      {
        icon: "AssemblyIcon",
        name: "製品",
      },
      {
        icon: "MedicalCrossIcon",
        name: "医師・医療従事者",
      },
    ],
  },
];

const articles: Array<{
  locale: string;
  data: Array<ArticleBusiness>;
}> = [
  {
    locale: "en",
    data: [
      {
        image: "/categories/retail-01-content-small.jpg",
        title: "Promote deals and offers effectively",
        description:
          "Use this QR Code in your sales strategy so you can attract new customers and reward loyal ones with unbeatable travel and tour packages.",
      },
      {
        image: "/categories/nonprofits-02-content-small.jpg",
        title: "Make it easy to save contact details",
        description:
          "Extend the functionalities of your business card by using this QR Code with essential information to easily connect with your network.",
      },
      {
        image: "/categories/finance-insurance-02-content-small.jpg",
        title: "Share a downloadable PDF file",
        description:
          "Use this QR Code to share and display manuals, ebooks, catalogs, or any other PDF file so it can be easily viewed and downloaded.",
      },
      {
        image: "/categories/personal-use-01-content-small.jpg",
        title: "Share photos in a digital gallery",
        description:
          "Trouble picking a favorite image to share with friends and family? Display them all beautifully in a gallery style with this QR Code.",
      },
      {
        image: "/categories/business-consultants-02-content-small.jpg",
        title: "Present a collection of your best work",
        description:
          "Use your business card as a marketing tool and add this QR Code to add images of your best work so you’d always have your portfolio handy.",
      },
      {
        image: "/categories/retail-02-content-small.jpg",
        title: "Increase your social media followers",
        description:
          "This QR Code makes networking fast as it displays all the social media channels you own to make it easier for your fans to follow you.",
      },
      {
        image: "/categories/home-repair-01-content-small.jpg",
        title: "Promote your company and services",
        description:
          "This QR Code lets you advertise your company on a mini-website so you can share info such as operating hours, location, and more.",
      },
      {
        image: "/categories/hotels-resorts-01-content-small.jpg",
        title: "Collect feedback or rating easily",
        description:
          "With a single scan, this QR Code allows your customers to leave their feedback and rating so you could improve your facilities and services.",
      },
      {
        image: "/categories/cities-culture-01-content-small.jpg",
        title: "Promote points of interest",
        description:
          "Use this QR Code to share and display brochures, free downloadable maps, or list of local recommendations for tourists to download easily.",
      },
      {
        image: "/categories/event-management-01-content-small.jpg",
        title: "Create calendar invites effortlessly",
        description:
          "Promote any event with this QR Code and let guests save the date easily to their calendars with information such as date, time and location",
      },
      {
        image: "/categories/restaurants-bars-01-content-small.jpg",
        title: "Create a contactless menu",
        description:
          "Upload your menu into the PDF QR Code so your customers can safely view it on their smartphones with a single scan.",
      },
      {
        image: "/categories/publishers-02-content-small.jpg",
        title: "Boost engagement with video content",
        description:
          "Having a video trailer is helpful to reach a wider audience, which is why this QR Code is perfect to promote any content in an engaging way.",
      },
      {
        image: "/categories/government-01-content-small.jpg",
        title: "Share info even without a website",
        description:
          "This QR Code lets you advertise your government office on a mini-website so you can share info such as operating hours, location, and more.",
      },
      {
        image: "/categories/musician-artists-01-content-small.jpg",
        title: "Share your music samples",
        description:
          "Use your business card as a marketing tool and add this QR Code so you can show off your latest single or have your music sample handy.",
      },
      {
        image: "/categories/real-estate-01-content-small.jpg",
        title: "Present a collection of your listing",
        description:
          "This QR Code allows you to always have your company presentation handy so you could place it on brochures, flyers, or business cards.",
      },
      {
        image: "/categories/hotels-resorts-02-content-small.jpg",
        title: "Display a gallery of images beautifully",
        description:
          "Use this QR Code to show off images of your hotel …han just one image on your promotional materials.",
      },
      {
        image: "/categories/software-it-01-content-small.jpg",
        title: "Link your app from different app stores",
        description:
          "Whether you have an app in Apple App Store, Google Play or even on Amazon Appstore, you can link them all in one place using this QR Code.",
      },
    ],
  },
  {
    locale: "zh",
    data: [
      {
        image: "/categories/retail-01-content-small.jpg",
        title: "有效推广促销和优惠活动",
        description:
          "使用此QR码将旅游和旅行套餐的优惠吸引新客户并奖励忠实的客户，让您的销售策略更加有效。",
      },
      {
        image: "/categories/nonprofits-02-content-small.jpg",
        title: "轻松保存联系方式",
        description:
          "通过使用QR码与基本信息，扩展您的名片的功能，便于与您的网络联系。",
      },
      {
        image: "/categories/finance-insurance-02-content-small.jpg",
        title: "共享可下载的PDF文件",
        description:
          "使用此QR码共享和显示手册、电子书、目录或任何其他PDF文件，以便轻松查看和下载。",
      },
      {
        image: "/categories/personal-use-01-content-small.jpg",
        title: "在数字画廊中分享照片",
        description:
          "在展示您的照片时，难以选择一个最喜欢的图像与朋友和家人分享吗？使用此QR码以画廊样式美观地显示所有照片。",
      },
      {
        image: "/categories/business-consultants-02-content-small.jpg",
        title: "展示您最好的作品集",
        description:
          "使用您的名片作为营销工具，并添加此QR码以添加您最好的作品图像，以便随时使用您的作品集。",
      },
      {
        image: "/categories/retail-02-content-small.jpg",
        title: "增加您的社交媒体粉丝",
        description:
          "此QR码可使网络化快速展开，因为它显示您拥有的所有社交媒体频道，以便更轻松地关注您的粉丝。",
      },
      {
        image: "/categories/home-repair-01-content-small.jpg",
        title: "宣传您的公司和服务",
        description:
          "此QR码使您可以在迷你网站上为您的公司做广告，因此您可以共享营业时间、位置等信息。",
      },
      {
        image: "/categories/hotels-resorts-01-content-small.jpg",
        title: "轻松收集反馈或评分",
        description:
          "通过单次扫描，此QR码允许您的客户留下反馈和评分，以便您可以改进设施和服务。",
      },
      {
        image: "/categories/cities-culture-01-content-small.jpg",
        title: "宣传有趣的景点",
        description:
          "使用此QR码共享和显示旅游者可以轻松下载的小册子、免费地图或当地推荐列表。",
      },

      {
        image: "/categories/event-management-01-content-small.jpg",
        title: "轻松创建日历邀请",
        description:
          "使用此QR码宣传任何活动，并让客人通过扫描QR码将日期、时间和地点等信息轻松保存到他们的日历中。",
      },
      {
        image: "/categories/restaurants-bars-01-content-small.jpg",
        title: "创建非接触式菜单",
        description:
          "将菜单上传到PDF QR码中，这样您的客人就可以通过单个扫描安全地在智能手机上查看它。",
      },
      {
        image: "/categories/publishers-02-content-small.jpg",
        title: "以视频内容推广",
        description:
          "拥有视频预告片可以帮助您吸引更广泛的受众，这就是为什么这个QR码是促进任何内容引人入胜的理想选择。",
      },
      {
        image: "/categories/government-01-content-small.jpg",
        title: "即使没有网站也可以分享信息",
        description:
          "这个QR码让您在一个迷你网站上宣传您的政府办公室，以便您可以分享开放时间、位置等信息。",
      },
      {
        image: "/categories/musician-artists-01-content-small.jpg",
        title: "分享您的音乐样本",
        description:
          "使用您的名片作为营销工具，并添加此QR码，这样您就可以展示最新单曲或随时携带您的音乐样本。",
      },
      {
        image: "/categories/real-estate-01-content-small.jpg",
        title: "展示您的房源收藏",
        description:
          "这个QR码允许您随时携带公司介绍资料，因此您可以将其放在宣传册、传单或名片上。",
      },
      {
        image: "/categories/hotels-resorts-02-content-small.jpg",
        title: "优美地展示图像库",
        description:
          "使用此QR码展示您酒店的图像，而不仅仅是在宣传材料上放一张图像。",
      },
      {
        image: "/categories/software-it-01-content-small.jpg",
        title: "链接不同应用商店中的应用程序",
        description:
          "无论您的应用程序是在Apple App Store、Google Play甚至是在Amazon Appstore中，您都可以使用此QR码将它们链接在一个地方。",
      },
    ],
  },
  {
    locale: "vi",
    data: [
      {
        image: "/categories/retail-01-content-small.jpg",
        title: "Quảng cáo các ưu đãi hiệu quả",
        description:
          "Sử dụng mã QR này trong chiến lược bán hàng của bạn để thu hút khách hàng mới và thưởng cho những khách hàng trung thành với các gói du lịch không thể chối từ.",
      },
      {
        image: "/categories/nonprofits-02-content-small.jpg",
        title: "Dễ dàng lưu thông tin liên hệ",
        description:
          "Mở rộng tính năng của thẻ danh thiếp của bạn bằng cách sử dụng mã QR này với thông tin cần thiết để dễ dàng kết nối với mạng lưới của bạn.",
      },
      {
        image: "/categories/finance-insurance-02-content-small.jpg",
        title: "Chia sẻ tệp PDF có thể tải xuống",
        description:
          "Sử dụng mã QR này để chia sẻ và hiển thị các tài liệu, sách điện tử, danh mục hoặc bất kỳ tệp PDF nào khác để có thể xem và tải xuống dễ dàng.",
      },
      {
        image: "/categories/personal-use-01-content-small.jpg",
        title: "Chia sẻ ảnh trong một bộ sưu tập số",
        description:
          "Gặp khó khăn trong việc chọn một ảnh yêu thích để chia sẻ với gia đình và bạn bè? Hiển thị tất cả chúng một cách đẹp mắt trong một kiểu dáng bộ sưu tập với mã QR này.",
      },
      {
        image: "/categories/business-consultants-02-content-small.jpg",
        title: "Trình bày một bộ sưu tập những tác phẩm tốt nhất của bạn",
        description:
          "Sử dụng thẻ danh thiếp của bạn như một công cụ tiếp thị và thêm mã QR này để thêm hình ảnh của những tác phẩm tốt nhất của bạn để bạn luôn có bản tóm tắt của mình.",
      },
      {
        image: "/categories/retail-02-content-small.jpg",
        title: "Tăng số lượng người theo dõi trên mạng xã hội",
        description:
          "Mã QR này giúp mạng lưới kết nối nhanh chóng khi hiển thị tất cả các kênh truyền thông xã hội của bạn để dễ dàng cho người hâm mộ của bạn theo dõi bạn.",
      },
      {
        image: "/categories/home-repair-01-content-small.jpg",
        title: "Quảng bá công ty và dịch vụ của bạn",
        description:
          "Mã QR này cho phép bạn quảng cáo công ty của mình trên một trang web nhỏ để bạn có thể chia sẻ thông tin như giờ làm việc, địa chỉ và nhiều hơn nữa.",
      },
      {
        image: "/categories/hotels-resorts-01-content-small.jpg",
        title: "Thu thập đánh giá hoặc đánh giá dễ dàng",
        description:
          "Với một lần quét, mã QR này cho phép khách hàng của bạn để lại phản hồi và đánh giá để bạn có thể cải thiện cơ sở vật chất và dịch vụ của mình.",
      },
      {
        image: "/categories/cities-culture-01-content-small.jpg",
        title: "Quảng bá các điểm đến hấp dẫn",
        description:
          "Sử dụng mã QR này để chia sẻ và hiển thị các tờ rơi, bản đồ tải xuống miễn phí hoặc danh sách các địa điểm địa phương được đề xuất cho du khách tải xuống dễ dàng.",
      },
      {
        image: "/categories/event-management-01-content-small.jpg",
        title: "Tạo lời mời lịch trình một cách dễ dàng",
        description:
          "Quảng bá bất kỳ sự kiện nào với mã QR này và cho phép khách mời lưu ngày dễ dàng vào lịch của họ với thông tin như ngày, giờ và địa điểm.",
      },
      {
        image: "/categories/restaurants-bars-01-content-small.jpg",
        title: "Tạo menu không tiếp xúc",
        description:
          "Tải lên menu của bạn vào mã QR PDF để khách hàng của bạn có thể an toàn xem trên điện thoại thông minh chỉ với một lần quét.",
      },
      {
        image: "/categories/publishers-02-content-small.jpg",
        title: "Tăng cường tương tác với nội dung video",
        description:
          "Có một video trailer là hữu ích để tiếp cận một đối tượng khán giả rộng hơn, đó là lý do tại sao mã QR này là hoàn hảo để quảng bá bất kỳ nội dung nào một cách hấp dẫn.",
      },
      {
        image: "/categories/government-01-content-small.jpg",
        title: "Chia sẻ thông tin mà không cần website",
        description:
          "Mã QR này cho phép bạn quảng cáo văn phòng chính phủ của mình trên một mini-website để bạn có thể chia sẻ thông tin như giờ làm việc, địa điểm và nhiều hơn nữa.",
      },
      {
        image: "/categories/musician-artists-01-content-small.jpg",
        title: "Chia sẻ các mẫu âm nhạc của bạn",
        description:
          "Sử dụng thẻ danh thiếp của bạn như một công cụ tiếp thị và thêm mã QR này để bạn có thể trình diễn bản nhạc mới nhất của mình hoặc có mẫu nhạc của bạn sẵn sàng.",
      },
      {
        image: "/categories/real-estate-01-content-small.jpg",
        title: "Trình bày bộ sưu tập các bất động sản của bạn",
        description:
          "Mã QR này cho phép bạn luôn luôn có bản trình bày công ty của bạn sẵn sàng để đặt trên tờ rơi, tờ quảng cáo hoặc thẻ danh thiếp.",
      },
      {
        image: "/categories/hotels-resorts-02-content-small.jpg",
        title: "Hiển thị bộ sưu tập hình ảnh một cách đẹp mắt",
        description:
          "Sử dụng mã QR này để trưng bày các hình ảnh của khách sạn của bạn một cách đẹp mắt hơn chỉ một hình ảnh trên các tài liệu quảng cáo của bạn.",
      },
      {
        image: "/categories/software-it-01-content-small.jpg",
        title: "Liên kết ứng dụng của bạn từ các cửa hàng ứng dụng khác nhau",
        description:
          "Cho dù bạn có ứng dụng trên Apple App Store, Google Play hay thậm chí trên Amazon Appstore, bạn có thể liên kết tất cả chúng trong một địa điểm bằng cách sử dụng mã QR này.",
      },
    ],
  },
  {
    locale: "de",
    data: [
      {
        image: "/categories/retail-01-content-small.jpg",
        title: "Effektive Werbung von Deals und Angeboten",
        description:
          "Nutzen Sie diesen QR-Code in Ihrer Verkaufsstrategie, um neue Kunden anzulocken und treue Kunden mit unschlagbaren Reise- und Tourangeboten zu belohnen.",
      },
      {
        image: "/categories/nonprofits-02-content-small.jpg",
        title: "Kontaktdaten einfach speichern",
        description:
          "Erweitern Sie die Funktionen Ihrer Visitenkarte durch die Verwendung dieses QR-Codes mit wichtigen Informationen, um sich einfach mit Ihrem Netzwerk zu verbinden.",
      },
      {
        image: "/categories/finance-insurance-02-content-small.jpg",
        title: "Freigabe einer herunterladbaren PDF-Datei",
        description:
          "Verwenden Sie diesen QR-Code, um Handbücher, E-Books, Kataloge oder jede andere PDF-Datei zu teilen und anzuzeigen, damit sie leicht angezeigt und heruntergeladen werden kann.",
      },
      {
        image: "/categories/personal-use-01-content-small.jpg",
        title: "Fotos in einer digitalen Galerie teilen",
        description:
          "Schwierigkeiten bei der Auswahl eines Lieblingsbildes, das mit Freunden und Familie geteilt werden soll? Zeigen Sie sie alle auf eine schöne Weise in einer Galerie mit diesem QR-Code an.",
      },
      {
        image: "/categories/business-consultants-02-content-small.jpg",
        title: "Präsentieren Sie eine Sammlung Ihrer besten Arbeit",
        description:
          "Verwenden Sie Ihre Visitenkarte als Marketinginstrument und fügen Sie diesen QR-Code hinzu, um Bilder Ihrer besten Arbeit hinzuzufügen, damit Sie immer Ihr Portfolio griffbereit haben.",
      },
      {
        image: "/categories/retail-02-content-small.jpg",
        title: "Erhöhen Sie Ihre Social-Media-Follower",
        description:
          "Dieser QR-Code macht Networking schnell, da er alle sozialen Medien anzeigt, die Sie besitzen, um es Ihren Fans einfacher zu machen, Ihnen zu folgen.",
      },
      {
        image: "/categories/home-repair-01-content-small.jpg",
        title: "Werbung für Ihr Unternehmen und Ihre Dienstleistungen",
        description:
          "Dieser QR-Code ermöglicht es Ihnen, für Ihr Unternehmen auf einer Mini-Website zu werben, damit Sie Informationen wie Öffnungszeiten, Standort und mehr teilen können.",
      },
      {
        image: "/categories/hotels-resorts-01-content-small.jpg",
        title: "Sammeln Sie Feedback oder Bewertungen einfach",
        description:
          "Mit einem einzigen Scan ermöglicht Ihnen dieser QR-Code, dass Ihre Kunden ihr Feedback und ihre Bewertung hinterlassen können, damit Sie Ihre Einrichtungen und Dienstleistungen verbessern können.",
      },
      {
        image: "/categories/cities-culture-01-content-small.jpg",
        title: "Fördern Sie Sehenswürdigkeiten",
        description: "",
      },
      {
        image: "/categories/event-management-01-content-small.jpg",
        title: "Erstellen Sie mühelos Kalendereinladungen",
        description:
          "Fördern Sie jede Veranstaltung mit diesem QR-Code und lassen Sie Gäste das Datum einfach in ihren Kalendern mit Informationen wie Datum, Uhrzeit und Ort speichern.",
      },
      {
        image: "/categories/restaurants-bars-01-content-small.jpg",
        title: "Erstellen Sie eine kontaktlose Speisekarte",
        description:
          "Laden Sie Ihre Speisekarte in den PDF-QR-Code hoch, damit Ihre Kunden sie sicher auf ihren Smartphones mit einem einzigen Scan anzeigen können.",
      },
      {
        image: "/categories/publishers-02-content-small.jpg",
        title: "Steigern Sie die Interaktion mit Videoinhalten",
        description:
          "Ein Trailer-Video ist hilfreich, um ein breiteres Publikum zu erreichen, deshalb ist dieser QR-Code perfekt, um Inhalte auf eine ansprechende Art und Weise zu bewerben.",
      },
      {
        image: "/categories/government-01-content-small.jpg",
        title: "Teilen Sie Informationen auch ohne Website",
        description:
          "Dieser QR-Code ermöglicht es Ihnen, Ihr Regierungsbüro auf einer Mini-Website zu bewerben, damit Sie Informationen wie Öffnungszeiten, Standort und mehr teilen können.",
      },
      {
        image: "/categories/musician-artists-01-content-small.jpg",
        title: "Teilen Sie Ihre Musikproben",
        description:
          "Verwenden Sie Ihre Visitenkarte als Marketing-Tool und fügen Sie diesen QR-Code hinzu, damit Sie Ihren neuesten Song präsentieren oder Ihre Musikprobe griffbereit haben können.",
      },
      {
        image: "/categories/real-estate-01-content-small.jpg",
        title: "Stellen Sie eine Sammlung Ihrer Angebote vor",
        description:
          "Dieser QR-Code ermöglicht es Ihnen, Ihre Firmenpräsentation immer griffbereit zu haben, damit Sie sie auf Broschüren, Flyern oder Visitenkarten platzieren können.",
      },
      {
        image: "/categories/hotels-resorts-02-content-small.jpg",
        title: "Zeigen Sie eine Galerie von Bildern wunderschön an",
        description:
          "Verwenden Sie diesen QR-Code, um Bilder Ihres Hotels zu präsentieren ... als nur ein Bild auf Ihren Werbematerialien.",
      },
      {
        image: "/categories/software-it-01-content-small.jpg",
        title: "Verlinken Sie Ihre App aus verschiedenen App-Stores",
        description:
          "Egal, ob Sie eine App im Apple App Store, Google Play oder sogar im Amazon Appstore haben, Sie können sie alle an einem Ort mit diesem QR-Code verlinken.",
      },
    ],
  },
  {
    locale: "it",
    data: [
      {
        image: "/categories/retail-01-content-small.jpg",
        title: "Promuovi offerte e promozioni in modo efficace",
        description:
          "Utilizza questo codice QR nella tua strategia di vendita per attirare nuovi clienti e premiare quelli fedeli con pacchetti di viaggio e tour imbattibili.",
      },
      {
        image: "/categories/nonprofits-02-content-small.jpg",
        title: "Rendi facile salvare i dettagli dei contatti",
        description:
          "Estendi le funzionalità del tuo biglietto da visita utilizzando questo codice QR con informazioni essenziali per collegarti facilmente alla tua rete.",
      },
      {
        image: "/categories/finance-insurance-02-content-small.jpg",
        title: "Condividi un file PDF scaricabile",
        description:
          "Utilizza questo codice QR per condividere e visualizzare manuali, e-book, cataloghi o qualsiasi altro file PDF in modo che possa essere facilmente visualizzato e scaricato.",
      },
      {
        image: "/categories/personal-use-01-content-small.jpg",
        title: "Condividi foto in una galleria digitale",
        description:
          "Hai difficoltà a scegliere un'immagine preferita da condividere con amici e familiari? Mostrale tutte in modo splendido con uno stile di galleria utilizzando questo codice QR.",
      },
      {
        image: "/categories/business-consultants-02-content-small.jpg",
        title: "Presenta una collezione del tuo miglior lavoro",
        description:
          "Utilizza il tuo biglietto da visita come strumento di marketing e aggiungi questo codice QR per aggiungere immagini del tuo miglior lavoro in modo che tu abbia sempre il tuo portfolio a portata di mano.",
      },
      {
        image: "/categories/retail-02-content-small.jpg",
        title: "Aumenta i tuoi follower sui social media",
        description:
          "Questo codice QR rende il networking veloce in quanto visualizza tutti i canali di social media di cui sei proprietario per facilitare ai tuoi fan il seguirti.",
      },
      {
        image: "/categories/home-repair-01-content-small.jpg",
        title: "Promuovi la tua azienda e i tuoi servizi",
        description:
          "Questo codice QR ti consente di pubblicizzare la tua azienda su un mini-sito web in modo da poter condividere informazioni come orari di apertura, posizione e altro ancora.",
      },
      {
        image: "/categories/hotels-resorts-01-content-small.jpg",
        title: "Raccogli facilmente feedback o valutazioni",
        description:
          "Con una sola scansione, questo codice QR consente ai tuoi clienti di lasciare il loro feedback e valutazione in modo che tu possa migliorare le tue strutture e i tuoi servizi.",
      },
      {
        image: "/categories/cities-culture-01-content-small.jpg",
        title: "Promuovere i punti di interesse",
        description:
          "Utilizza questo codice QR per condividere e visualizzare brochure, mappe scaricabili gratuitamente o elenchi di raccomandazioni locali per i turisti da scaricare facilmente.",
      },
      {
        image: "/categories/event-management-01-content-small.jpg",
        title: "Creare inviti al calendario senza sforzo",
        description:
          "Promuovi qualsiasi evento con questo codice QR e permetti agli ospiti di salvare facilmente la data nei loro calendari con informazioni come data, ora e luogo.",
      },
      {
        image: "/categories/restaurants-bars-01-content-small.jpg",
        title: "Creare un menu senza contatto",
        description:
          "Carica il tuo menu nel codice QR PDF in modo che i tuoi clienti possano visualizzarlo in modo sicuro sui loro smartphone con una sola scansione.",
      },
      {
        image: "/categories/publishers-02-content-small.jpg",
        title: "Aumentare l'engagement con contenuti video",
        description:
          "Avere un trailer video è utile per raggiungere un pubblico più vasto, ecco perché questo codice QR è perfetto per promuovere qualsiasi contenuto in modo coinvolgente.",
      },
      {
        image: "/categories/government-01-content-small.jpg",
        title: "Condividere informazioni anche senza un sito web",
        description:
          "Questo codice QR ti consente di pubblicizzare il tuo ufficio governativo su un mini-sito web in modo da poter condividere informazioni come gli orari di apertura, la posizione e altro ancora.",
      },
      {
        image: "/categories/musician-artists-01-content-small.jpg",
        title: "Condividere i tuoi campioni musicali",
        description:
          "Utilizza il tuo biglietto da visita come strumento di marketing e aggiungi questo codice QR in modo da poter mostrare il tuo ultimo singolo o avere a portata di mano il campione della tua musica.",
      },
      {
        image: "/categories/real-estate-01-content-small.jpg",
        title: "Presentare una collezione delle tue offerte",
        description:
          "Questo codice QR ti consente di avere sempre a portata di mano la presentazione della tua azienda in modo da poterla posizionare su opuscoli, volantini o biglietti da visita.",
      },
      {
        image: "/categories/hotels-resorts-02-content-small.jpg",
        title: "Visualizzare una galleria di immagini in modo bello",
        description:
          "Utilizza questo codice QR per mostrare immagini del tuo hotel in una galleria, invece di limitarti a una sola immagine sui tuoi materiali promozionali.",
      },
      {
        image: "/categories/software-it-01-content-small.jpg",
        title: "Collega la tua app da diversi app store",
        description:
          "Che tu abbia un'app nell'Apple App Store, in Google Play o persino nell'Amazon Appstore, puoi collegarle tutte in un unico posto utilizzando questo codice QR.",
      },
    ],
  },
  {
    locale: "es",
    data: [
      {
        image: "/categories/retail-01-content-small.jpg",
        title: "Promociona ofertas y descuentos de manera efectiva",
        description:
          "Utiliza este código QR en tu estrategia de ventas para atraer a nuevos clientes y recompensar a los leales con paquetes de viaje y turismo inigualables.",
      },
      {
        image: "/categories/nonprofits-02-content-small.jpg",
        title: "Facilita el guardado de información de contacto",
        description:
          "Extiende las funcionalidades de tu tarjeta de presentación utilizando este código QR con información esencial para conectarte fácilmente con tu red de contactos.",
      },
      {
        image: "/categories/finance-insurance-02-content-small.jpg",
        title: "Comparte un archivo PDF descargable",
        description:
          "Utiliza este código QR para compartir y mostrar manuales, libros electrónicos, catálogos o cualquier otro archivo PDF para que pueda ser fácilmente visto y descargado.",
      },
      {
        image: "/categories/personal-use-01-content-small.jpg",
        title: "Comparte fotos en una galería digital",
        description:
          "¿Tienes problemas para elegir una imagen favorita para compartir con amigos y familiares? Muéstralas todas de manera hermosa en una galería con este código QR.",
      },
      {
        image: "/categories/business-consultants-02-content-small.jpg",
        title: "Presenta una colección de tu mejor trabajo",
        description:
          "Utiliza tu tarjeta de presentación como herramienta de marketing y agrega este código QR para añadir imágenes de tu mejor trabajo para que siempre tengas tu portafolio a mano.",
      },
      {
        image: "/categories/retail-02-content-small.jpg",
        title: "Aumenta tus seguidores en las redes sociales",
        description:
          "Este código QR hace que la creación de redes sea más rápida, ya que muestra todos los canales de redes sociales que posees para que sea más fácil para tus fans seguirte.",
      },
      {
        image: "/categories/home-repair-01-content-small.jpg",
        title: "Promociona tu empresa y servicios",
        description:
          "Este código QR te permite anunciar tu empresa en un mini sitio web para que puedas compartir información como horarios de atención, ubicación y más.",
      },
      {
        image: "/categories/hotels-resorts-01-content-small.jpg",
        title: "Recibe retroalimentación o calificaciones fácilmente",
        description:
          "Con un solo escaneo, este código QR permite a tus clientes dejar sus comentarios y calificaciones para que puedas mejorar tus instalaciones y servicios.",
      },
      {
        image: "/categories/cities-culture-01-content-small.jpg",
        title: "Promocionar puntos de interés",
        description:
          "Utilice este código QR para compartir y mostrar folletos, mapas descargables gratuitos o una lista de recomendaciones locales para que los turistas los descarguen fácilmente.",
      },
      {
        image: "/categories/event-management-01-content-small.jpg",
        title: "Crear invitaciones para eventos sin esfuerzo",
        description:
          "Promocione cualquier evento con este código QR y permita que los invitados guarden fácilmente la fecha en sus calendarios con información como fecha, hora y ubicación.",
      },
      {
        image: "/categories/restaurants-bars-01-content-small.jpg",
        title: "Crear un menú sin contacto",
        description:
          "Cargue su menú en el código QR de PDF para que sus clientes puedan verlo de forma segura en sus teléfonos inteligentes con una sola escaneo.",
      },
      {
        image: "/categories/publishers-02-content-small.jpg",
        title: "Aumentar la participación con contenido de video",
        description:
          "Tener un avance de video es útil para llegar a una audiencia más amplia, por lo que este código QR es perfecto para promocionar cualquier contenido de manera atractiva.",
      },
      {
        image: "/categories/government-01-content-small.jpg",
        title: "Compartir información incluso sin un sitio web",
        description:
          "Este código QR le permite publicitar su oficina gubernamental en un mini sitio web para que pueda compartir información como horarios de atención, ubicación y más.",
      },
      {
        image: "/categories/musician-artists-01-content-small.jpg",
        title: "Compartir sus muestras de música",
        description:
          "Utilice su tarjeta de presentación como herramienta de marketing y agregue este código QR para poder mostrar su última canción o tener su muestra de música a mano.",
      },
      {
        image: "/categories/real-estate-01-content-small.jpg",
        title: "Presentar una colección de sus listados",
        description:
          "Este código QR le permite tener siempre a mano la presentación de su empresa para que pueda colocarla en folletos, volantes o tarjetas de presentación.",
      },
      {
        image: "/categories/hotels-resorts-02-content-small.jpg",
        title: "Mostrar una galería de imágenes de manera hermosa",
        description:
          "Utilice este código QR para mostrar imágenes de su hotel de una manera más atractiva que solo una imagen en sus materiales promocionales.",
      },
      {
        image: "/categories/software-it-01-content-small.jpg",
        title: "Enlazar su aplicación desde diferentes tiendas de aplicaciones",
        description:
          "Ya sea que tenga una aplicación en Apple App Store, Google Play o incluso en Amazon Appstore, puede enlazarlas todas en un solo lugar utilizando este código QR.",
      },
    ],
  },
  {
    locale: "fr",
    data: [
      {
        image: "/categories/retail-01-content-small.jpg",
        title: "Promouvoir efficacement les offres et les promotions",
        description:
          "Utilisez ce QR Code dans votre stratégie de vente pour attirer de nouveaux clients et récompenser les fidèles avec des offres de voyage et de tour imbattables.",
      },
      {
        image: "/categories/nonprofits-02-content-small.jpg",
        title: "Faciliter la sauvegarde des coordonnées",
        description:
          "Étendez les fonctionnalités de votre carte de visite en utilisant ce QR Code avec des informations essentielles pour vous connecter facilement avec votre réseau.",
      },
      {
        image: "/categories/finance-insurance-02-content-small.jpg",
        title: "Partager un fichier PDF téléchargeable",
        description:
          "Utilisez ce QR Code pour partager et afficher des manuels, des livres électroniques, des catalogues ou tout autre fichier PDF afin qu'il puisse être facilement consulté et téléchargé.",
      },
      {
        image: "/categories/personal-use-01-content-small.jpg",
        title: "Partager des photos dans une galerie numérique",
        description:
          "Difficulté à choisir une image favorite à partager avec vos amis et votre famille ? Affichez-les toutes de manière élégante dans une galerie avec ce QR Code.",
      },
      {
        image: "/categories/business-consultants-02-content-small.jpg",
        title: "Présenter une collection de votre meilleur travail",
        description:
          "Utilisez votre carte de visite comme outil de marketing et ajoutez ce QR Code pour ajouter des images de votre meilleur travail afin que vous ayez toujours votre portfolio à portée de main.",
      },
      {
        image: "/categories/retail-02-content-small.jpg",
        title: "Augmenter le nombre de vos abonnés sur les réseaux sociaux",
        description:
          "Ce QR Code permet un networking rapide en affichant tous les canaux de médias sociaux que vous possédez pour faciliter le suivi de vos fans.",
      },
      {
        image: "/categories/home-repair-01-content-small.jpg",
        title: "Promouvoir votre entreprise et vos services",
        description:
          "Ce QR Code vous permet de faire la publicité de votre entreprise sur un mini-site web afin que vous puissiez partager des informations telles que les heures d'ouverture, l'emplacement et plus encore.",
      },
      {
        image: "/categories/hotels-resorts-01-content-small.jpg",
        title: "Collecter facilement les commentaires ou les évaluations",
        description:
          "Avec une seule numérisation, ce QR Code permet à vos clients de laisser leurs commentaires et leur évaluation afin que vous puissiez améliorer vos installations et services.",
      },
      {
        image: "/categories/cities-culture-01-content-small.jpg",
        title: "Promouvoir les points d'intérêt",
        description:
          "Utilisez ce code QR pour partager et afficher des brochures, des cartes téléchargeables gratuitement ou une liste de recommandations locales pour que les touristes puissent les télécharger facilement.",
      },
      {
        image: "/categories/event-management-01-content-small.jpg",
        title: "Créer des invitations de calendrier facilement",
        description:
          "Promouvoir n'importe quel événement avec ce code QR et permettre aux invités de facilement enregistrer la date dans leur calendrier avec des informations telles que la date, l'heure et le lieu.",
      },
      {
        image: "/categories/restaurants-bars-01-content-small.jpg",
        title: "Créer un menu sans contact",
        description:
          "Téléchargez votre menu dans le code QR PDF pour que vos clients puissent le consulter en toute sécurité sur leur smartphone en un seul scan.",
      },
      {
        image: "/categories/publishers-02-content-small.jpg",
        title: "Booster l'engagement avec du contenu vidéo",
        description:
          "Avoir une bande-annonce vidéo est utile pour atteindre un public plus large, c'est pourquoi ce code QR est parfait pour promouvoir tout contenu de manière engageante.",
      },
      {
        image: "/categories/government-01-content-small.jpg",
        title: "Partager des informations même sans site web",
        description:
          "Ce code QR vous permet de faire de la publicité pour votre bureau gouvernemental sur un mini-site web afin de partager des informations telles que les heures d'ouverture, l'emplacement et plus encore.",
      },
      {
        image: "/categories/musician-artists-01-content-small.jpg",
        title: "Partager vos échantillons de musique",
        description:
          "Utilisez votre carte de visite comme outil de marketing et ajoutez ce code QR pour pouvoir présenter votre dernier single ou avoir un échantillon de votre musique à portée de main.",
      },
      {
        image: "/categories/real-estate-01-content-small.jpg",
        title: "Présenter une collection de vos listes",
        description:
          "Ce code QR vous permet d'avoir toujours votre présentation d'entreprise à portée de main afin que vous puissiez la placer sur des brochures, des dépliants ou des cartes de visite.",
      },
      {
        image: "/categories/hotels-resorts-02-content-small.jpg",
        title: "Afficher une galerie d'images magnifiquement",
        description:
          "Utilisez ce code QR pour mettre en valeur les images de votre hôtel ...au lieu d'une seule image sur vos supports promotionnels.",
      },
      {
        image: "/categories/software-it-01-content-small.jpg",
        title:
          "Lier votre application à partir de différentes boutiques d'applications",
        description:
          "Que vous ayez une application dans l'App Store d'Apple, Google Play ou même sur l'Appstore d'Amazon, vous pouvez les lier tous en un seul endroit en utilisant ce code QR.",
      },
    ],
  },
  {
    locale: "pt",
    data: [
      {
        image: "/categories/retail-01-content-small.jpg",
        title: "Promova promoções e ofertas de forma eficaz",
        description:
          "Use este código QR em sua estratégia de vendas para atrair novos clientes e recompensar os leais com pacotes de viagem e turismo imbatíveis.",
      },
      {
        image: "/categories/nonprofits-02-content-small.jpg",
        title: "Facilite a salvaguarda de informações de contato",
        description:
          "Estenda as funcionalidades do seu cartão de visita usando este código QR com informações essenciais para se conectar facilmente com sua rede.",
      },
      {
        image: "/categories/finance-insurance-02-content-small.jpg",
        title: "Compartilhe um arquivo PDF para download",
        description:
          "Use este código QR para compartilhar e exibir manuais, e-books, catálogos ou qualquer outro arquivo PDF para que possam ser facilmente visualizados e baixados.",
      },
      {
        image: "/categories/personal-use-01-content-small.jpg",
        title: "Compartilhe fotos em uma galeria digital",
        description:
          "Com dificuldade em escolher uma imagem favorita para compartilhar com amigos e familiares? Exiba-as todas de forma elegante em um estilo de galeria com este código QR.",
      },
      {
        image: "/categories/business-consultants-02-content-small.jpg",
        title: "Apresente uma coleção do seu melhor trabalho",
        description:
          "Use seu cartão de visita como uma ferramenta de marketing e adicione este código QR para adicionar imagens do seu melhor trabalho para que você sempre tenha seu portfólio à mão.",
      },
      {
        image: "/categories/retail-02-content-small.jpg",
        title: "Aumente seus seguidores nas redes sociais",
        description:
          "Este código QR torna a rede de contatos mais rápida, pois exibe todos os canais de mídia social que você possui para que seja mais fácil para seus fãs segui-lo.",
      },
      {
        image: "/categories/home-repair-01-content-small.jpg",
        title: "Promova sua empresa e serviços",
        description:
          "Este código QR permite que você anuncie sua empresa em um mini-site para que você possa compartilhar informações, como horários de funcionamento, localização e muito mais.",
      },
      {
        image: "/categories/hotels-resorts-01-content-small.jpg",
        title: "Coleta de feedback ou avaliação facilmente",
        description:
          "Com uma única digitalização, este código QR permite que seus clientes deixem seus comentários e avaliações para que você possa melhorar suas instalações e serviços.",
      },
      {
        image: "/categories/cities-culture-01-content-small.jpg",
        title: "Promover pontos de interesse",
        description:
          "Use este QR Code para compartilhar e exibir brochuras, mapas gratuitos para download ou lista de recomendações locais para que turistas possam baixar facilmente.",
      },
      {
        image: "/categories/event-management-01-content-small.jpg",
        title: "Criar convites para calendário sem esforço",
        description:
          "Promova qualquer evento com este QR Code e permita que os convidados salvem a data facilmente em seus calendários, com informações como data, hora e localização.",
      },
      {
        image: "/categories/restaurants-bars-01-content-small.jpg",
        title: "Criar um menu sem contato",
        description:
          "Carregue o seu menu no PDF QR Code para que os seus clientes possam visualizá-lo com segurança em seus smartphones com apenas um scan.",
      },
      {
        image: "/categories/publishers-02-content-small.jpg",
        title: "Aumentar o engajamento com conteúdo de vídeo",
        description:
          "Ter um trailer de vídeo é útil para alcançar um público mais amplo, por isso este QR Code é perfeito para promover qualquer conteúdo de forma envolvente.",
      },
      {
        image: "/categories/government-01-content-small.jpg",
        title: "Compartilhar informações mesmo sem um site",
        description:
          "Este QR Code permite que você divulgue seu escritório governamental em um mini-site, para que você possa compartilhar informações como horário de funcionamento, localização e muito mais.",
      },
      {
        image: "/categories/musician-artists-01-content-small.jpg",
        title: "Compartilhar suas amostras de música",
        description:
          "Use o seu cartão de visita como uma ferramenta de marketing e adicione este QR Code para poder exibir sua última música ou ter sua amostra de música à mão.",
      },
      {
        image: "/categories/real-estate-01-content-small.jpg",
        title: "Apresentar uma coleção de suas listagens",
        description:
          "Este QR Code permite que você sempre tenha sua apresentação da empresa à mão, para que possa colocá-la em brochuras, folhetos ou cartões de visita.",
      },
      {
        image: "/categories/hotels-resorts-02-content-small.jpg",
        title: "Exibir uma galeria de imagens com beleza",
        description:
          "Use este QR Code para mostrar imagens de seu hotel de forma mais atraente, em vez de ter apenas uma imagem em seus materiais promocionais.",
      },
      {
        image: "/categories/software-it-01-content-small.jpg",
        title: "Link seu aplicativo em diferentes lojas de aplicativos",
        description:
          "Independentemente de ter um aplicativo na Apple App Store, Google Play ou até mesmo na Amazon Appstore, você pode vinculá-los todos em um só lugar usando este QR Code.",
      },
    ],
  },
  {
    locale: "nl",
    data: [
      {
        image: "/categories/retail-01-content-small.jpg",
        title: "Promoot deals en aanbiedingen effectief",
        description:
          "Gebruik deze QR-code in uw verkoopstrategie, zodat u nieuwe klanten kunt aantrekken en loyale klanten kunt belonen met onverslaanbare reis- en tourpakketten.",
      },
      {
        image: "/categories/nonprofits-02-content-small.jpg",
        title: "Maak het gemakkelijk om contactgegevens op te slaan",
        description:
          "Breid de functionaliteiten van uw visitekaartje uit door deze QR-code te gebruiken met essentiële informatie om gemakkelijk contact te maken met uw netwerk.",
      },
      {
        image: "/categories/finance-insurance-02-content-small.jpg",
        title: "Deel een downloadbaar PDF-bestand",
        description:
          "Gebruik deze QR-code om handleidingen, e-books, catalogi of elk ander PDF-bestand te delen en weer te geven, zodat het gemakkelijk kan worden bekeken en gedownload.",
      },
      {
        image: "/categories/personal-use-01-content-small.jpg",
        title: "Deel foto's in een digitale galerij",
        description:
          "Problemen met het kiezen van een favoriete afbeelding om te delen met vrienden en familie? Laat ze allemaal prachtig zien in een galerijstijl met deze QR-code.",
      },
      {
        image: "/categories/business-consultants-02-content-small.jpg",
        title: "Presenteer een verzameling van uw beste werk",
        description:
          "Gebruik uw visitekaartje als marketinginstrument en voeg deze QR-code toe om afbeeldingen van uw beste werk toe te voegen, zodat u uw portfolio altijd bij de hand hebt.",
      },
      {
        image: "/categories/retail-02-content-small.jpg",
        title: "Verhoog uw aantal volgers op sociale media",
        description:
          "Deze QR-code maakt netwerken snel omdat het al uw eigen sociale mediakanalen weergeeft om het gemakkelijker te maken voor uw fans om u te volgen.",
      },
      {
        image: "/categories/home-repair-01-content-small.jpg",
        title: "Promoot uw bedrijf en diensten",
        description:
          "Deze QR-code stelt u in staat uw bedrijf te adverteren op een mini-website, zodat u informatie kunt delen zoals openingstijden, locatie en meer.",
      },
      {
        image: "/categories/hotels-resorts-01-content-small.jpg",
        title: "Verzamel gemakkelijk feedback of beoordelingen",
        description:
          "Met een enkele scan maakt deze QR-code het voor uw klanten mogelijk om feedback en beoordelingen achter te laten, zodat u uw faciliteiten en diensten kunt verbeteren.",
      },
      {
        image: "/categories/cities-culture-01-content-small.jpg",
        title: "Bevorder bezienswaardigheden",
        description:
          "Gebruik deze QR-code om brochures, gratis te downloaden kaarten of lijsten met lokale aanbevelingen te delen en weer te geven voor toeristen om gemakkelijk te downloaden.",
      },
      {
        image: "/categories/event-management-01-content-small.jpg",
        title: "Maak gemakkelijk kalenderuitnodigingen",
        description:
          "Promoot elk evenement met deze QR-code en laat gasten gemakkelijk de datum opslaan in hun agenda's met informatie zoals datum, tijd en locatie.",
      },
      {
        image: "/categories/restaurants-bars-01-content-small.jpg",
        title: "Maak een contactloos menu",
        description:
          "Upload uw menu in de PDF QR-code, zodat uw klanten het veilig op hun smartphones kunnen bekijken met een enkele scan.",
      },
      {
        image: "/categories/publishers-02-content-small.jpg",
        title: "Verhoog de betrokkenheid met videomateriaal",
        description:
          "Een videotrailer hebben is nuttig om een breder publiek te bereiken, daarom is deze QR-code perfect om elk content op een boeiende manier te promoten.",
      },
      {
        image: "/categories/government-01-content-small.jpg",
        title: "Deel informatie, zelfs zonder een website",
        description:
          "Met deze QR-code kunt u uw overheidskantoor adverteren op een mini-website, zodat u informatie zoals openingstijden, locatie en meer kunt delen.",
      },
      {
        image: "/categories/musician-artists-01-content-small.jpg",
        title: "Deel uw muziekvoorbeelden",
        description:
          "Gebruik uw visitekaartje als marketinginstrument en voeg deze QR-code toe, zodat u uw nieuwste single kunt laten zien of uw muziekvoorbeeld bij de hand hebt.",
      },
      {
        image: "/categories/real-estate-01-content-small.jpg",
        title: "Presenteer een verzameling van uw aanbod",
        description:
          "Deze QR-code stelt u in staat om altijd uw bedrijfspresentatie bij de hand te hebben, zodat u deze op brochures, flyers of visitekaartjes kunt plaatsen.",
      },
      {
        image: "/categories/hotels-resorts-02-content-small.jpg",
        title: "Laat een prachtige galerij van afbeeldingen zien",
        description:
          "Gebruik deze QR-code om afbeeldingen van uw hotel te laten zien ... dan slechts één afbeelding op uw promotionele materialen.",
      },
      {
        image: "/categories/software-it-01-content-small.jpg",
        title: "Link uw app vanuit verschillende app stores",
        description:
          "Of u nu een app heeft in de Apple App Store, Google Play of zelfs in de Amazon Appstore, u kunt ze allemaal op één plek linken met behulp van deze QR-code.",
      },
    ],
  },
  {
    locale: "ja",
    data: [
      {
        image: "/categories/retail-01-content-small.jpg",
        title: "効果的にセールやオファーを宣伝する",
        description:
          "このQRコードを販売戦略に活用し、新規顧客を獲得し、既存顧客には破格の旅行やツアーパッケージを提供しましょう。",
      },
      {
        image: "/categories/nonprofits-02-content-small.jpg",
        title: "連絡先情報を簡単に保存する",
        description:
          "必要な情報が含まれたこのQRコードを名刺に加えることで、簡単にネットワークに接続できます。",
      },
      {
        image: "/categories/finance-insurance-02-content-small.jpg",
        title: "ダウンロード可能なPDFファイルを共有する",
        description:
          "このQRコードを使用してマニュアル、電子書籍、カタログ、その他のPDFファイルを共有し、簡単に表示およびダウンロードできるようにしましょう。",
      },
      {
        image: "/categories/personal-use-01-content-small.jpg",
        title: "デジタルギャラリーで写真を共有する",
        description:
          "友人や家族と共有するお気に入りの画像を選ぶのが難しい場合は、このQRコードでギャラリースタイルで美しく表示しましょう。",
      },
      {
        image: "/categories/business-consultants-02-content-small.jpg",
        title: "あなたの最高の仕事のコレクションを紹介する",
        description:
          "このQRコードを追加することで、名刺をマーケティングツールとして活用し、最高の仕事の画像を常に手元に置くことができます。",
      },
      {
        image: "/categories/retail-02-content-small.jpg",
        title: "ソーシャルメディアのフォロワーを増やす",
        description:
          "このQRコードを使用すると、所有するすべてのソーシャルメディアチャンネルを表示して、ファンがあなたをフォローしやすくします。",
      },
      {
        image: "/categories/home-repair-01-content-small.jpg",
        title: "会社やサービスを宣伝する",
        description:
          "このQRコードを使用すると、ミニウェブサイトで会社の情報を共有できるため、営業時間、場所などを広告することができます。",
      },
      {
        image: "/categories/hotels-resorts-01-content-small.jpg",
        title: "フィードバックや評価を簡単に収集",
        description:
          "このQRコードをスキャンするだけで、お客様にフィードバックや評価を残していただくことができます。その情報をもとに、施設やサービスの改善に役立てることができます。",
      },
      {
        image: "/categories/cities-culture-01-content-small.jpg",
        title: "観光スポットを宣伝",
        description:
          "このQRコードを利用して、パンフレットや無料のダウンロード可能な地図、またはローカルなおすすめリストなどを共有・表示することができます。観光客が簡単にダウンロードできるようにすることができます。",
      },
      {
        image: "/categories/event-management-01-content-small.jpg",
        title: "カレンダーの予定を簡単に作成",
        description:
          "このQRコードを利用して、さまざまなイベントを宣伝し、日付、時間、場所などの情報を含んだカレンダーの予定を簡単に作成することができます。",
      },
      {
        image: "/categories/restaurants-bars-01-content-small.jpg",
        title: "コンタクトレスメニューを作成",
        description:
          "PDF QRコードにメニューをアップロードすることで、お客様がスマートフォンで安全に表示できるようにすることができます。",
      },
      {
        image: "/categories/publishers-02-content-small.jpg",
        title: "ビデオコンテンツでエンゲージメントを向上",
        description:
          "ビデオトレーラーを持っていると、より広い視聴者にアプローチできるので、このQRコードは、エンゲージメントを向上させるために、あらゆるコンテンツを宣伝するのに最適です。",
      },
      {
        image: "/categories/government-01-content-small.jpg",
        title: "ウェブサイトがなくても情報を共有",
        description:
          "このQRコードを利用すると、政府機関の情報をミニウェブサイトで宣伝できるため、営業時間、場所などの情報を共有することができます。",
      },
      {
        image: "/categories/musician-artists-01-content-small.jpg",
        title: "あなたの音楽サンプルを共有する",
        description:
          "あなたのビジネスカードをマーケティングツールとして活用し、このQRコードを追加することで、最新シングルを披露したり、音楽サンプルを手軽に持ち歩くことができます。",
      },
      {
        image: "/categories/real-estate-01-content-small.jpg",
        title: "物件のコレクションをプレゼンテーションする",
        description:
          "このQRコードを使えば、常に会社のプレゼンテーションを手軽に持ち歩くことができるので、パンフレット、フライヤー、またはビジネスカードに掲載することができます。",
      },
      {
        image: "/categories/hotels-resorts-02-content-small.jpg",
        title: "美しく画像のギャラリーを表示する",
        description:
          "このQRコードを使って、ホテルの画像を1枚だけではなく、複数の画像をプロモーションツールに掲載することができます。",
      },
      {
        image: "/categories/software-it-01-content-small.jpg",
        title: "異なるアプリストアからアプリにリンクする",
        description:
          "Apple App Store、Google Play、Amazon Appstoreなど、複数のアプリストアにアプリを持っている場合でも、このQRコードを使ってすべてのアプリを1つの場所でリンクすることができます。",
      },
    ],
  },
];
